import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from 'react-router-dom';
import { CompaniesContainer } from "./CompaniesStyled";
import { FormattedMessage } from 'react-intl';

import back from './../../utils/images/arrow_back.svg';
import dropDownPink from './../../utils/images/arrow_down_pink.svg';
import dropDownPinkUp from './../../utils/images/arrow_down_pink_up.svg';

import { getAllCompanies } from "../../api/companyApi";

import CompanyCard from "../../components/CompanyCard/CompanyCard";
import { LangContext } from "../../context/langContext";
import Rating from '@mui/material/Rating';
import Stack from '@mui/material/Stack';
import Spinner from "../../components/Spinner/Spinner";


export default function Companies() {

    const navigate = useNavigate();
    const { locale } = useContext(LangContext);

    const [limit, setLimit] = useState(12);
    const [offset, setOffset] = useState(0);
    const [isLoading, setIsLoading] = useState(true);

    const [total, setTotal] = useState(0);
    const [companies, setCompanies] = useState([]);

    const [showFilterByFollowers, setShowFilterByFollowers] = useState(false);
    const [showFilterByCollaborations, setShowFilterByCollaborations] = useState(false);

    const [ratingFilter, setRatingFilter] = useState(null);

    const seeMore = () => {
        setOffset(offset + limit);
    }

    /**------Vendrá de back------- */
    const followerOptions = [{ nombre: '1m+', name: '1m+' }, { nombre: '500k+', name: '500k+' }, { nombre: '100k+', name: '100k+' }, { nombre: '10k+', name: '10k+' }, { nombre: 'menos 10k', name: 'less 10k' }]

    const collaborationsOptions = [{ nombre: '0 - 24', name: '0 - 24' }, { nombre: '25 - 49', name: '25 - 49' }, { nombre: '50 - 99', name: '50 - 99' }, { nombre: '100+', name: '100+' }]

    useEffect(() => {
        let query = '';
        if (ratingFilter !== null) {
            query = query + `&rating=gte.${ratingFilter}`
        }
        if (offset > 0) {
            getAllCompanies({ limit: limit, offset: offset, query }).then(({ data, pagination }) => {
                const auxCompanies = companies.concat(data);
                setCompanies(auxCompanies);
                setTotal(pagination.split('/')[1]);
                setIsLoading(false);

            })
        }
    }, [offset])

    useEffect(() => {
        let query = '';
        if (ratingFilter !== null) {
            query = query + `&rating=gte.${ratingFilter}`
        }

        getAllCompanies({ limit: limit, offset: offset, query }).then(({ data, pagination }) => {
            setCompanies(data);
            setTotal(pagination.split('/')[1]);
            setIsLoading(false);
            setLimit(12);
            setOffset(0);

        })
    }, [ratingFilter])

    return (
        <CompaniesContainer>
            {/* <div className="goBack" onClick={() => navigate(-1)}>
                <img src={back} alt="go back" className="backIcon" />
                <p >
                    <FormattedMessage id="go_back" defaultMessage="ir atrás" />
                </p>
            </div> */}
            <div className="companiesBody">
                <div className="menu">

                    <div className="filterTitle"><FormattedMessage id="companies_menu_option_1" defaultMessage="Filtrar por" /></div>

                    {/* <div className="filter">

                        <div className="filterName">
                            <span><FormattedMessage id="companies_menu_option_2" defaultMessage="# de seguidores" /></span>
                            <img src={(showFilterByFollowers) ? dropDownPinkUp : dropDownPink} alt="" onClick={() => { setShowFilterByFollowers(!showFilterByFollowers) }} />
                        </div>
                        {(showFilterByFollowers) && (<div className="options">

                            {followerOptions.map((language) => (<label for={language.name} className='option'> <input type="checkbox" id={language.name} name="age" value={language.name} />{(locale === 'es-CO') ? language.nombre : language.name}</label>))}

                        </div>)}
                    </div> */}

                    {/* <div className="filter">
                        <div className="filterName">
                            <span><FormattedMessage id="companies_menu_option_3" defaultMessage="# de colaboraciones" /></span>
                            <img src={(showFilterByCollaborations) ? dropDownPinkUp : dropDownPink} alt="" onClick={() => { setShowFilterByCollaborations(!showFilterByCollaborations) }} />
                        </div>
                        {(showFilterByCollaborations) && (<div className="options">

                            {collaborationsOptions.map((language) => (<label for={language.name} className='option'> <input type="checkbox" id={language.name} name="age" value={language.name} />{(locale === 'es-CO') ? language.nombre : language.name}</label>))}

                        </div>)}
                    </div> */}

                    <div className="filter">
                        <div className="filterName">
                            <p><FormattedMessage id="companies_menu_option_8" defaultMessage="Rango" /></p>
                        </div>
                        <Stack spacing={1}>
                            <Rating style={{ color: '#E8339E' }} name="size-large" /* defaultValue={2} */ size="large" precision={0.5} value={ratingFilter} onChange={(event, newValue) => {
                                setRatingFilter(newValue);
                                setOffset(0);
                            }} />
                        </Stack>
                    </div>

                </div>
                <div className="companiesContent">
                    <div className="results">
                        <p className="totalResults">{total} <FormattedMessage id="companies_text_1" defaultMessage="resultados" /></p>
                        {/* <div className="orderBy">
                            <p>
                                <FormattedMessage id="companies_text_2" defaultMessage="Ordenar por" />
                            </p>
                            <img src={dropDownPink} alt="" />
                        </div> */}
                    </div>
                    <div className="cards">
                        {companies.map((company) => (
                            <CompanyCard company={company} key={company.id} />
                        ))}
                    </div>
                    {(limit + offset < total) && (<p className="seeMore" onClick={seeMore}><FormattedMessage id="companies_text_3" defaultMessage="Ver más +" /></p>)}
                </div>

            </div>
            {(isLoading) && (<Spinner />)}

        </CompaniesContainer>
    )
}